/**
 * 人名组件
 */
import { MemberPicker, SelectValue } from '@tencent/udesign/dist';

import {
  getDynamicSelectedValue,
  getDynamicSelectOption,
  getPlaceholderConfig,
  isSelectUserComponent,
} from '../../../libs';
import { FieldType, IConfigField, IValue } from '../../../model';

export const TOP_OA_HTTP = '//top.woa.com/'; // 人名域名

interface IPropsSelectUser<L> {
  readonly fieldConfig: IConfigField<L>;
  readonly onChanged: <T>(key: string, value: T) => void;
  readonly selectedValue: IValue;
  readonly isFilterModeView: boolean;
  readonly className?: string;
}
export const DynamicSelectUser = <T,>(props: IPropsSelectUser<T>) => {
  const { isFilterModeView, fieldConfig, selectedValue } = props;
  const isMultiple =
    fieldConfig.filter_type === FieldType.user_chooser_multiple;
  const isDefaultOpen =
    fieldConfig?.filterOptExtension?.isDefaultOpen !== false;
  if (isFilterModeView) {
    const filterOptExtension = isSelectUserComponent(
      fieldConfig.filterOptExtension
    );
    if (!filterOptExtension) {
      return null;
    }

    const placeholder = getPlaceholderConfig(fieldConfig);
    const newValue = getDynamicSelectedValue(selectedValue, isMultiple);
    const options = getDynamicSelectOption(
      selectedValue.value,
      fieldConfig?.fieldOptExtension?.data
    );

    const onChanged = (value: SelectValue) => {
      props.onChanged(fieldConfig.key, value);
    };

    return (
      <MemberPicker
        options={options.length > 0 ? options : undefined}
        url={`${TOP_OA_HTTP}/js/users.js`}
        value={newValue}
        onChanged={onChanged}
        placeholder={placeholder}
        maxSelected={!isMultiple ? 1 : undefined}
        isMultiple={isMultiple}
        className={props.className}
        {...filterOptExtension}
        isDefaultOpen={isDefaultOpen}
        extendedConfig={{
          ignoreCase: true,
          supportSelectedTop: true,
        }}
      />
    );
  }

  return <span>{selectedValue.value}</span>;
};
